import type {
  VendorDetailsFormSchema,
  VendorDetailsQuerySchema,
} from '@/_pages/settings/inventory-kits/shared/schemas/vendor-details';
import { currencyInput } from '@/_schemas/generic';

export function vendorDetailsQueryToForm(
  vendor_details?: VendorDetailsQuerySchema[] | null
): VendorDetailsFormSchema[] {
  return (
    vendor_details?.map((vendor) => ({
      ...vendor,
      vendor_note: vendor.vendor_note ?? '',
      vendor_sku: vendor.vendor_sku ?? '',
      vendor_url: vendor.vendor_url ?? '',
      last_price: currencyInput.queryToFormConverter(vendor.last_price),
    })) ?? []
  );
}
